export default "__VITE_ASSET__1fdf886b__"